import type { Tournament, TournamentOfChampions } from './types';

/**
 * Does `tournament` belong to one of `tournamentOfChampions`'s own rounds? Matched by
 * `tournamentGroupKey` — the single definition of "does TOC own this tournament", shared by
 * `TournamentOfChampionsStore.shouldRenderDialog` and `selectTournamentDialogVariant` so the two
 * can't quietly drift apart on what counts as a TOC-owned round.
 */
export const isTournamentOwnedByToc = (
  tournament: Tournament | null | undefined,
  tournamentOfChampions: TournamentOfChampions | null,
): boolean =>
  !!tournamentOfChampions &&
  !!tournament &&
  tournamentOfChampions.rounds.some((round) => round.tournamentGroupKey === tournament.tournamentGroupKey);
